import React from "react";
import { ArrowLeft } from "lucide-react";
import { Link, useLocation, useNavigate } from 'react-router-dom'

interface BackLinkProps {
  to: string;
  children: React.ReactNode;
}

const BackLink: React.FC<BackLinkProps> = ({ to, children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const from = (location.state as any)?.from as string | undefined;
  const fromLabel = (location.state as any)?.fromLabel as string | undefined;

  const label = fromLabel ? `Back to ${fromLabel}` : children;

  const handleClick = (e: React.MouseEvent) => {
    if (from) {
      e.preventDefault();
      navigate(-1);
    }
  };

  return (
    <Link
      to={from || to}
      onClick={handleClick}
      className="flex items-center gap-2 text-sm text-muted-foreground mb-4 hover:text-foreground"
    >
      <ArrowLeft className="h-4 w-4" />
      {typeof label === 'string' ? label : children}
    </Link>
  );
};

export default BackLink;
